import * as Accordion from '@bambi/component-library/src/components/Accordion/Accordion';
import { Badge } from '@bambi/component-library/src/components/Badge/Badge';

type AccordionFilterItemProps = {
  children: React.ReactNode;
  badgeLabel: string | number;
  itemName: string;
  label: string;
};

export default function AccordionFilterItem({
  children,
  badgeLabel,
  itemName,
  label,
}: AccordionFilterItemProps) {
  return (
    <Accordion.Root
      type="single"
      collapsible
      className="rounded-md border p-2"
      data-testid={`${itemName}-filter-accordion`}
    >
      <Accordion.Item value={itemName} data-testid={`${itemName}-filter-item`}>
        <Accordion.Trigger data-testid={`${itemName}-filter-trigger`}>
          <div className="flex w-full items-center justify-between">
            <div className="text-sm">{label}</div>
            <Badge
              color="primary"
              label={String(badgeLabel)}
              testId={`${itemName}-filter-count-badge`}
            />
          </div>
        </Accordion.Trigger>
        <Accordion.Content className="py-2">{children}</Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
}
